import React from 'react';
import { Link } from 'gatsby';
import { FaGithub, FaYoutube } from 'react-icons/fa';

const Navbar = () => {
  return(
  <div className='NavbarStyle'>
    <Link to='/' title='Repos' activeClassName='active'><FaGithub style={{ color: '#333333' }} className='ico' /> Repos</Link>
    <Link to='/videos' title='Videos' activeClassName='active'><FaYoutube style={{ color: '#ff0000' }} className='ico' /> Videos</Link>
  </div>
  );
}
export default Navbar;